import { Tab, Tabs, styled } from '../../../base';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.primary.main,
        width: '2px',
        insetInlineEnd: 0,
        right: 'inherit',
    },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(14),
    minHeight: '48px',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: theme.spacing(1.5, 2),
    fontWeight: theme.typography.fontWeightMedium,
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    '&.Mui-selected': {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.grey[100],
        fontWeight: theme.typography.fontWeightBold,
    },
    '&:not(.Mui-selected)': {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.grey[100],
    },
    '&:hover': {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '&:focus': {
        outline: 'none',
    },
}));
